import React, { Component } from "react";
import { connect } from "react-redux";
import SignVendorAgreement from "containers/request/SignVendorAgreement";
import RequestResultPage from "components/request/RequestResultPage";
import Stepper from "components/Stepper";
import steps from "components/Stepper/ecoSteps";
import PageHeader from "components/request/RequestPageHeader";
import InfoBar from "containers/request/ECO/InfoBar";
import EcoTabs from "containers/request/ECO/EcoTabs";
import { clearModel } from "actions/model";
import { clearRequest, createEcoRequest } from "actions/request";
import { initWizard, clearWizard } from "actions/wizard";

class EcoSubmitPage extends Component {
  // init redux storage with default values for a request and a wizard
  componentDidMount() {
    this.props.createEcoRequest(this.props.user.name);
    this.props.initWizard();
  }

  componentWillUnmount() {
    this.props.clearRequest();
    this.props.clearModel();
    this.props.clearWizard();
  }

  render() {
    const { request, wizard, history, user } = this.props;

    if (!user.cbrsvendoragreementflag) return <SignVendorAgreement />;

    if (request === null || wizard === null) {
      return "Loading...";
    }

    if (request.newId) {
      return (
        <RequestResultPage
          isEco={true}
          isSubmit={wizard.isSubmitted}
          history={history}
        />
      );
    }

    return (
      <div>
        <PageHeader />
        <Stepper show={true} steps={steps} />
        <InfoBar />
        <EcoTabs />
      </div>
    );
  }
}

function mapStateToProps({ request, user, wizard }) {
  return { request, user, wizard };
}

export default connect(mapStateToProps, {
  createEcoRequest,
  initWizard,
  clearRequest,
  clearWizard,
  clearModel
})(EcoSubmitPage);



// WEBPACK FOOTER //
// ./src/containers/request/ECO/EcoSubmitPage.js